<template>
  <div class="exam w-full lg:w-[800px] mx-auto lg:mt-4">
    <div class="card rounded-lg mb-4 lg:mb-8 relative">
      <img src="/img/exam/selfcheck.svg" class="relative lg:absolute mb-[-30px] lg:mb-0 lg:-top-2 lg:left-[-230px] w-1/2 lg:w-auto" alt="">
      <div class="lg:pl-44 lg:py-8 p-4">
        <h2 class="h1  mb-4" v-html="__('exam.selfcheck_transition.title')"></h2>

        <p class="h2 mb-4 font-semibold text-secondary-300">{{ __('exam.selfcheck_transition.subheader')}}</p>

        <p class="mb-4">{{ __('exam.selfcheck_transition.copy')}}</p>

        <button class="btn btn-success" @click="continueSelfcheck">
          {{ __('exam.selfcheck_transition.btn')}}
        </button>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'ExamSelfcheckTransition',

  props: {
    exam: {
      type: Object,
      required: false,
    },
    test: {
      type: Object,
      required: false,
    },
  },
  emits: ['continue'],

  data() {
    return {}
  },

  methods: {
    continueSelfcheck: function () {
      this.$emit('continue')
    },
  },

}
</script>

<style scoped>

</style>
